import axiosInstance from "../utils/axios";

export const GetBlockedIps = async () => {
    return await axiosInstance().get("admin/security/blocked-ips");
}

export const UnblockIp = async (values) => {
    return await axiosInstance().post("admin/security/unblock-ip", values);
}

export const GetRedisStats = async () => {
    return await axiosInstance().get("admin/security/redis-stats");
}

export const GetRedisCompanySummary = async () => {
    return await axiosInstance().get("admin/security/redis-company-summary");
}

export const GetRedisCompanyKeys = async (values) => {
    return await axiosInstance().post("admin/security/redis-company-keys", values);
}

export const RedisFlush = async (values) => {
    return await axiosInstance().post("admin/security/redis-flush", values);
}
